import { render, staticRenderFns } from "./ItemsAssociationInput.vue?vue&type=template&id=3fa6735e&scoped=true"
import script from "./ItemsAssociationInput.vue?vue&type=script&lang=js"
export * from "./ItemsAssociationInput.vue?vue&type=script&lang=js"
import style0 from "./ItemsAssociationInput.vue?vue&type=style&index=0&id=3fa6735e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6735e",
  null
  
)

export default component.exports